import React from 'react';

const Confirmation = () => {
    return (
        <>
            <h5 className="mb-3 text-center text-base font-medium text-foreground">
                Password Reset
            </h5>
            <p className="mb-5 text-sm font-light text-foreground">
                Your password has been reset. Click below to login with your new
                password.
            </p>
        </>
    );
};

export default Confirmation;
